import { o_util } from "@gr-common/head/namespaces";
import { assignNamespace } from "@gr-common/head/namespace-utils";
import { toggle } from "@gr-exports/head/toggle";
import { cookie } from "@gr-exports/head/cookie";
import { deprecated } from "@gr-common/head/logger";

import { ajaxLegacy } from "./ajax/ajax.legacy.js";
import { ajax } from "./ajax/index.js";

import "./helper.js";

export interface LegacyUtils {
  legacy: {
    ajaxLegacy: typeof ajaxLegacy;
  };

  ajax: typeof ajax;
}

if (toggle.get("gr_legacy_ajax_enable", true)) {
  const oLegacy = o_util as unknown as LegacyUtils;

  assignNamespace(oLegacy, "legacy", {
    ajaxLegacy: deprecated(ajaxLegacy, "ajax", "ajaxLegacy", "use native fetch instead"),
  });

  oLegacy.ajax = ajax;
}

/**
 *
 *
 */
/*                                                                */
cookie.exists("app") && document.documentElement.classList.add("app");
